<template>
  <div v-if="loading" class="loader">Loading...</div>
  <div v-else>
    <canvas ref="revenueChartCanvas"></canvas>
  </div>
</template>

<script>
import { Chart, registerables } from 'chart.js'
import gql from 'graphql-tag'

// Register all Chart.js modules
Chart.register(...registerables)

export default {
  name: 'revenue-bar-chart',
  props: {
    selectedYear: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      chart: null,
      chartData: {
        labels: [],
        datasets: {
          totalFees: [],
          fixedFees: [],
          otherFees: [],
        },
      },
    }
  },
  async mounted() {
    await this.loadData()
    this.renderChart()
  },
  methods: {
    async loadData() {
      this.loading = true
      this.chartData.labels = []
      this.chartData.datasets = { totalFees: [], fixedFees: [], otherFees: [] }

      for (let i = 0; i < 12; i++) {
        const date = new Date(this.selectedYear, new Date().getMonth() - i, 1)

        // Fetch data for each month sequentially
        const { data } = await this.$apollo.query({
          query: gql`
            query GetMonthlyReport($year: Int!, $month: Int!) {
              getCoreEventMonthlyReport(year: $year, month: $month)
            }
          `,
          variables: {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
          },
        })

        const report = data.getCoreEventMonthlyReport
        this.chartData.labels.unshift(`${date.getMonth() + 1}/${date.getFullYear()}`)
        this.chartData.datasets.totalFees.unshift(report.totalCoreEventEarnings)
        this.chartData.datasets.fixedFees.unshift(report.totalCoreEventFixedFeeEarnings)
        this.chartData.datasets.otherFees.unshift(report.totalCoreEventEarnings - report.totalCoreEventFixedFeeEarnings)
      }

      this.loading = false
    },
    renderChart() {
      if (this.chart) {
        this.chart.destroy()
      }

      const ctx = this.$refs.revenueChartCanvas.getContext('2d')
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: this.chartData.labels,
          datasets: [
            {
              label: 'Ukupno Naknada',
              data: this.chartData.datasets.totalFees,
              backgroundColor: 'rgba(75, 192, 192, 0.2)',
              borderColor: 'rgba(75, 192, 192, 1)',
              borderWidth: 1,
              barThickness: 25, // Set thickness for this dataset
            },
            {
              label: 'Ukupno Fiksne Naknade',
              data: this.chartData.datasets.fixedFees,
              backgroundColor: 'rgba(54, 162, 235, 0.2)',
              borderColor: 'rgba(54, 162, 235, 1)',
              borderWidth: 1,
              barThickness: 10, // Thinner bar thickness
            },
            {
              label: 'Ukupno Ostale Naknade',
              data: this.chartData.datasets.otherFees,
              backgroundColor: 'rgba(255, 206, 86, 0.2)',
              borderColor: 'rgba(255, 206, 86, 1)',
              borderWidth: 1,
              barThickness: 10, // Thinner bar thickness
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: 'top',
            },
            title: {
              display: true,
              text: 'Monthly Revenue Report - Last 12 Months',
            },
          },
        },
      })
    },
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy()
    }
  },
}
</script>

<style scoped>
.loader {
  text-align: center;
  margin-top: 50px;
}
</style>
